import './script.js';
import './news.js';
import './tabs.js';
import './call-banner.js';
import './wow-init.js';
